import React, { useState, useRef } from "react";
import { AnInputBox } from "./AnInput";
import { DEFAULT_OTP_LENGTH } from "../../PreAuthRender/verification/OtpVerification";

const AnOtpInput = ({ length = DEFAULT_OTP_LENGTH, otp, setVerifyState, errors, onSubmit, ...props }) => {
  const dashPosition = Math.floor(length / 2);
  const inputRefs = useRef([]);

  const handleChange = (index, e) => {
    const value = e.target.value.replace(/\D/, ""); // Allow only numbers
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setVerifyState({otp: newOtp, errors: {}})
      if (value && index < length - 1) {
        inputRefs.current[index + 1].focus();
      }

    //   if (newOtp.join("").length === length) {
    //     onSubmit && onSubmit(newOtp.join(""));   //Auto Submit
    //   }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };
  
  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, length);
    if (/^\d+$/.test(pasteData)) {
      const newOtp = pasteData.split("").concat(new Array(length - pasteData.length).fill(""));
      setVerifyState({otp: newOtp})
      inputRefs.current[length - 1].focus();
    }
  };

  return (
    <div className="otp-input-container" onPaste={handlePaste}>
      {otp?.map((digit, index) => (
        <React.Fragment key={index}>
            <div className={`otp-input-box ${errors?.otp_invalid ? 'otp-input-error' : ''}`}>
                <input
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleChange(index, e)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    ref={(el) => (inputRefs.current[index] = el)}
                />
            </div>
          {index === dashPosition - 1 && <span className="otp-separator">—</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default AnOtpInput;
